export enum PolicyItem {
    LivingAreaCalculation = 'LIVING_AREA_CALCULATION',
    BuildingHullCalculation = 'BUILDING_HULL_CALCULATION',
    LockPeriodTariff = 'LOCK_PERIOD_TARIFF',
    HeatPumpPlanning = 'HEAT_PUMP_PLANNING',
    PhotovoltaicPlanning = 'PHOTOVOLTAIC_PLANNING'
}
